const enum PeopleCardRouteIdType {
    None,
    PersonaId = 'pid',
    Email = 'email',
    Group = 'group',
    DL = 'dl',
    CL = 'cl',
    CreateContact = 'create',
    ContactAdd = 'add',
    ContactEdit = 'edit',
}

export default PeopleCardRouteIdType;
